import { actions } from './customStylesReducer';

export const createStyleTag = (store: any) => (next: Function) => (
  action: any
) => {
  if (action.type === actions.UPDATE) {
    const { file } = action.payload;
    const existing = document.querySelector('style[data-global-style="true"]');
    if (existing) existing.innerHTML = file;
    else {
      const style = document.createElement('style');
      style.setAttribute('data-global-style', 'true');
      document.head.appendChild(style);
      style.innerHTML = file;
    }
  }
  return next(action);
};
